import {
  Box,
  Checkbox,
  CircularProgress,
  Typography,
  useMediaQuery
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useIsFetching } from "@tanstack/react-query";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { CoursesTable } from "./CoursesTable";
import { Button } from "../../components";
import { ButtonGroupsExternalTrainings } from "../../components/ButtonGroupsExternalTraining";
import { ContentBox, Description } from "../../components/CardProfile/CardProfile.styles";
import { CommonWidgetContainer } from "../../components/Commons/CommonWidgetContainer.styles";
import { ExternalSidebar } from "../../components/ExternalTraining/ExternalSidebar";
import { useExternalTrainingData } from "../../components/ExternalTraining/ExternalTrainingData";
import { ExternalTrainingPage } from "../../components/ExternalTraining/ExternalTrainingPage";
import { DataResponse, Options } from "../../components/InputCst/MultiSelectCst/types";
import { ExternalTrainingModal } from "../../components/Modal/ExternalTrainingModal";
import SidebarFilters from "../../components/Modal/SidebarFilter";
import { ModalBasic } from "../../components/ModalBasic";
import { useCapabilitiesOptionsQuery, useCourseTypesOptionsQuery, useCampaignsOptionsQuery, useDeleteExternalCertificate, useDeleteExternalTraining, useKnowledgeAreasOptionsQuery, useKnowledgeDomainsOptionsQuery, usePostExternalTrainingConsuntivazione } from "../../queries/skillbook";
import { Errors, Field, FormValues, MultiSelectOptionsProps, SkillBookExternal } from "../../routes/Profile/AddSkillBook/AddSkillBook.types";
import { useAuthStore } from "../../stores";
import { form_skillBook_add } from "../../utils/form_configurations";
import { onSubmitExternal } from "../../utils/skillBook";
import { Icon } from "../Icon/Icon.component";
import OutputMessageModal from "../Message/OutputMessageModal.component";



export function CompletedButton({
  completed,
  setCompleted,
  readOnly
}: {
  completed: boolean;
  setCompleted: React.Dispatch<React.SetStateAction<boolean>>;
  readOnly?: boolean;
}) {
  const { t } = useTranslation();
  const theme = useTheme();

  const toggleCompleted = () => {
    if (readOnly) return;
    setCompleted(prev => !prev);
  };

  return (
    <Box
      onClick={ readOnly ? undefined : toggleCompleted }
      aria-pressed={ completed }
      sx={ {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        backgroundColor: theme.customColors.backgroundPrimaryCta,
        borderRadius: "8px",
        padding: "12px 16px",
        cursor: "pointer",
        mt: 2
      } }
    >
      <Typography
        variant="h6"
        fontWeight="bold"
        color={ theme.customColors.textWidgetAlternative }
      >
        { t("comleted_button") }
      </Typography>

      <Checkbox
        checked={ completed }
        disableRipple
        sx={ {
          p: 0,
          "& svg": {
            fontSize: 24
          },
          "& .MuiSvgIcon-root path": {
            fill: theme.customColors.textWidgetAlternative
          }
        } }
        disabled={ readOnly }
      />
    </Box>
  );
}



export function SignupSummaryExternalTraining() {
  const { t } = useTranslation();
  const theme = useTheme();
  const [formValues, setFormValues] = React.useState<FormValues>({});
  const [errors, setErrors] = React.useState<Errors>({});
  const [courseTypes, setCourseTypes] = useState<Options[]>([]);
  const [campaignOptions, setCampaignOptions] = useState<Options[]>([]);


  const [knowledgeAreas, setKnowledgeAreas] = useState<MultiSelectOptionsProps[]>([]);
  const [knowledgeDomains, setKnowledgeDomains] = useState<MultiSelectOptionsProps[]>([]);
  const [capabilities, setCapabilities] = useState<MultiSelectOptionsProps[]>([]);
  const [selectedArea, setSelectedArea] = useState<{ isUpdating: boolean; value?: string | number }>({
    isUpdating: false,
    value: ""
  });
  const [filter, setFilter] = useState<string>("all");

  const [completed, setCompleted] = useState<boolean>(false);

  const handleFilterChange = (newFilter: string) => {
    setFilter(newFilter);
    setCurrentPage(1);
    setSelectedStatusFilter([]);
    setSearchTerm("");
    setSelectedCourse(null);
  };
  //const [selectedStatus, setSelectedStatus] = useState<string>("all");
  const [selectedStatusFilter, setSelectedStatusFilter] = useState<string[]>([]); // ARRAY

  const [searchTerm, setSearchTerm] = useState("");


  const handleDateChange = (name: string) => (date: Date | null) => {
    if (date instanceof Date && !isNaN(date.getTime())) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const formattedDate = `${year}-${month}-${day}`;

      setFormValues((prevValues) => ({
        ...prevValues,
        [name]: formattedDate
      }));
    } else {
      // Fallback: resetta o ignora
      console.warn(`❌ Data non valida per campo "${name}"`, date);
      setFormValues((prevValues) => ({
        ...prevValues,
        [name]: ""
      }));
    }
  };


  const [courses, setCourses] = useState<CourseItem[]>([]);
  const [selectedCourse, setSelectedCourse] = useState<CourseItem | null>(null);
  const handleSelectCourse = (course: CourseItem) => {
    setSelectedCourse(course);
    console.log("selected new course:",course);
  };

  // const filteredCourses = courses.filter(course => {
  //   const matchType =
  //     filter === "iscrizioni"
  //       ? course.type?.toLowerCase() === "iscrizione"
  //       : filter === "consuntivazione"
  //         ? course.type?.toLowerCase() === "consuntivazione"
  //         : true;

  //   const matchStatus =
  //     selectedStatus === "all" ? true : course.status === selectedStatus;

  //   const matchesSearch =
  //     course.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
  //     course.provider?.toLowerCase().includes(searchTerm.toLowerCase());

  //   return matchType && matchStatus && matchesSearch;
  // });

  const filteredCourses = courses.filter(course => {
    const matchType =
      filter === "iscrizioni"
        ? course.type?.toLowerCase() === "iscrizione"
        : filter === "consuntivazione"
          ? course.type?.toLowerCase() === "consuntivazione"
          : true;

    const matchStatus =
      selectedStatusFilter.length === 0          // array vuoto ⇒ mostra tutto
        ? true
        : selectedStatusFilter.includes(course.status);

    const matchesSearch =
      course.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
      course.provider?.toLowerCase().includes(searchTerm.toLowerCase());

    return matchType && matchStatus && matchesSearch;
  });


  //TODO sparisce un'iscrizione che ha lo stesso ID della consuntivazione?
  const mergeCoursesById = (prev: CourseItem[], next: CourseItem[]): CourseItem[] => {
    const combined = [...prev, ...next];
    return Array.from(new Map(combined.map(item => [item.id, item])).values());
  };

  const userId = useAuthStore(state => state.userData?.id_user) ?? "";
  const corporateId = useAuthStore(state => state.userData?.organization_id) ?? "";
  const name = useAuthStore(state => state.userData?.name) ?? "";
  const surname = useAuthStore(state => state.userData?.surname) ?? "";

  const handleChangeMultiSelect = (
    event: { label: string; value: string | number }[],
    accessorKey: string
  ) => {
    if (!["knowledgeArea", "knowledgeDomain", "capability"].includes(accessorKey)) return;
    let newValues: Options[] = [];

    const formValueArray = (formValues[accessorKey] as Options[]) || [];
    const itemsToAdd = event.filter(ev => !formValueArray.some(fv => fv.value === ev.value));
    const itemsToRemove = formValueArray.filter(fv => !event.some(ev => ev.value === fv.value));

    if (accessorKey === "knowledgeArea" && itemsToAdd[0])
      setSelectedArea({ isUpdating: true, value: itemsToAdd[0].value });

    if (accessorKey === "knowledgeArea" && itemsToRemove[0]) {
      const updatedDomains = knowledgeDomains.filter(domain =>
        itemsToRemove.every(item => domain.parent !== item.value)
      );
      setKnowledgeDomains(updatedDomains);
      setFormValues(prev => ({ ...prev, knowledgeDomain: [] }));
    }

    newValues = [
      ...formValueArray.filter(fv => !itemsToRemove.includes(fv)),
      ...itemsToAdd
    ];

    setFormValues(prev => ({ ...prev, [accessorKey]: newValues }));
  };


  useCapabilitiesOptionsQuery({
    onError: (error) => {
      console.error("Error fetching data Capabilities:", error);
    },
    onSuccess: (data: { output: [] }) => {
      const newCapabilities = data.output.map((item: DataResponse) => ({
        label: item.name,
        value: item.id
      }));

      setCapabilities(newCapabilities as MultiSelectOptionsProps[]);
    }
  });

  useCourseTypesOptionsQuery({
    onError: (error) => {
      console.error("Error fetching data Course Types:", error);
    },
    onSuccess: (data: unknown) => {
      const newCourseTypes = (data as DataResponse[]).map((item: DataResponse) => ({
        label: item.name || item.label,
        value: item.id ? String(item.id) : item.value ? String(item.value) : ""
      }));

      return setCourseTypes(newCourseTypes as Options[]);
    }
  });

  useCampaignsOptionsQuery({
    enabled: Boolean(corporateId),
    onError: (error) => {
      console.error("Error fetching campaigns:", error);
    },
    onSuccess: (data: unknown) => {

      console.log("campaigns fetched:",data);

      const campaigns = (data as { output: DataResponse[] }).output;

      const newCampaignOptions: Options[] = campaigns.map(item => ({
        label: item.name ?? "",
        value: String(item.id)
      }));

      setCampaignOptions(newCampaignOptions);
      console.log("campaigns fetched and cleaned:",campaignOptions);
    }
  });

  useKnowledgeAreasOptionsQuery({
    onError: (error) => {
      console.error("Error fetching data Areas:", error);
    },
    onSuccess: (data: { output: DataResponse[] }) => {
      const newKnowledgeArea = data.output.map((item: DataResponse) => ({
        label: item.name,
        value: item.id
      }));

      setKnowledgeAreas(newKnowledgeArea as MultiSelectOptionsProps[]);
    }
  });

  useKnowledgeDomainsOptionsQuery({
    onError: (error) => {
      console.error("Error fetching data Domains:", error);
    },
    onSuccess: (data: { output: DataResponse[] }) => {
      const areaId = selectedArea.isUpdating && selectedArea.value ? selectedArea.value.toString() : "";
      if (!areaId) return;
      const newKnowledgeDomain = data.output.map((item: DataResponse) => ({
        label: item.name,
        parent: selectedArea.value,
        value: item.id
      }));

      // newKnowledgeDomain.push(...knowledgeDomains as []);

      setKnowledgeDomains(newKnowledgeDomain as MultiSelectOptionsProps[]);
      setSelectedArea({ isUpdating: false });
      console.log("Data domain fetched successfully:", data);
    },
    knowledgeAreaId: selectedArea.isUpdating && selectedArea.value ? selectedArea.value.toString() : ""
  });

  // const [coursesAreLoading, setCoursesAreLoading] = useState<boolean>(true);

  const anyFetching = useIsFetching({
    predicate: q =>
      Array.isArray(q.queryKey) &&
      (q.queryKey[0] === "externalCert" || q.queryKey[0] === "externalTrain")
  }) > 0;
  const coursesAreLoading = courses.length === 0 && anyFetching;

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormValues(prev => ({ ...prev, [name]: value }));
  };
  const formData = form_skillBook_add.fields;

  const validateForm = () => {
    let newErrors: Errors = {};
    const today = new Date();
    const startDate =new Date(formValues.startDate as string);
    const endDate = new Date(formValues.endDate as string);
    const validationStartDate = new Date(formValues.validationStartDate as string);
    const validationEndDate = new Date(formValues.validationEndDate as string);
    formData.forEach((field: Field) => {
      if (field.required && !formValues[field.name] && field.name != "duration") {
        newErrors[field.name] = t(`${field.name}_required`);
      }
    });
    if (startDate > today) {
      newErrors.startDate = t("date_in_future_error");
    }
    if (endDate > today) {
      newErrors.endDate = t("date_in_future_error");
    }
    if (endDate < startDate) {
      newErrors.endDate = t("endDate_before_startDate_error");
    }
    if (validationEndDate < today) {
      newErrors.validationEndDate = t("certificate_expired");
    }
    if (validationEndDate < validationStartDate) {
      newErrors.validationEndDate = t("validationEndDate_before_validationStartDate_error");
    }
    if (validationStartDate < endDate) {
      newErrors.validationStartDate = t("validation_start_date_before_end_course");
    }

    if (formValues.duration !== "" && formValues.duration !== null && formValues.duration !== undefined) {
      const durationValue = Number(formValues.duration);

      if (isNaN(durationValue)) {
        newErrors.duration = t("duration_type_value_error");
      } else if (durationValue < 0) {
        newErrors.duration = t("duration_negative_value_error");
      }
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleConfirm = async () => {
    if (!selectedCourse?.id) {
      console.error("Nessuna iscrizione selezionata. L'id è richiesto.");
      // setOpen(true);
      return;
    }
    if (!validateForm()) {
      setErrors((prevErrors) => ({ ...prevErrors }));
      return;
    }

    // setIsOutputModalOpen(true);

    try {
      onSubmitExternal(
        formValues as unknown as SkillBookExternal,
        mutate as unknown as (data: FormData) => void,
        selectedCourse?.id
      );

      if (completed && selectedCourse.type === "Iscrizione") {
        setSuppressDeleteModal(true);
        //deleteExternalTraining(selectedCourse.id);
        handleRefresh();
      }
    } catch (error) {
      console.error("Errore durante la conferma:", error);
    }
  };

  const onCancel = () => {
    setFormValues({});
  };

  const [refreshKey, setRefreshKey] = useState(0);
  const handleRefresh = () => {
    setCourses([]);
    setRefreshKey(prev => prev + 1);
  };
  const [suppressDeleteModal, setSuppressDeleteModal] = useState(false);


  const { mutate: deleteExternalTraining } = useDeleteExternalTraining({

    onSuccess: () => {

      setDeleteSuccess(true);
      if (!suppressDeleteModal) {
        setIsDeleteModalOpen(true);
      }
      setSelectedCourse(null);

    },
    onError: (error) => {
      setDeleteSuccess(false);
      if (!suppressDeleteModal) {
        setIsDeleteModalOpen(true);
      }
      console.error(error);
    }
  });

  const { mutate: deleteExternalCertificate } = useDeleteExternalCertificate({
    onSuccess: () => {
      setDeleteSuccess(true);
      if (!suppressDeleteModal) {
        setIsDeleteModalOpen(true);
      }
      setIsDeleteModalOpen(true);
      setSelectedCourse(null);
    },
    onError: (error) => {
      setDeleteSuccess(false);
      if (!suppressDeleteModal) {
        setIsDeleteModalOpen(true);
      }
      console.error(error);
    }
  });


  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [deleteSuccess, setDeleteSuccess] = useState<boolean | null>(null);

  const onDelete = () => {
    if (!selectedCourse || selectedCourse.status !== "PENDING") return;
    if (selectedCourse.type === "Iscrizione") {
      deleteExternalTraining(selectedCourse.id);
    } else if (selectedCourse.type === "Consuntivazione") {
      deleteExternalCertificate(selectedCourse.id);
    }
  };


  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const sortedCourses = [...filteredCourses].sort((a, b) => {
    const dateA = a.endDate ? new Date(a.endDate).getTime() : 0;
    const dateB = b.endDate ? new Date(b.endDate).getTime() : 0;
    return dateB - dateA;
  });

  const paginatedCourses = sortedCourses.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );


  useExternalTrainingData(userId,corporateId,name,surname,setCourses,mergeCoursesById,refreshKey);

  // useEffect(() => {
  //   setCoursesAreLoading(false);
  // }, [courses]);

  const { mutate } = usePostExternalTrainingConsuntivazione({
    onSuccess: (data: unknown) => {
      console.log("Successo:", data);
      // setOpen(true);
      setSubmitSucceeded(true);
      setIsOutputModalOpen(true);
      handleRefresh();

      if (selectedCourse != null && selectedCourse.type === "Iscrizione") {
        setSuppressDeleteModal(true);

        // deleteExternalTraining(selectedCourse.id);
      }
    },
    onError: (error) => {
      console.error("Errore:", error);
      // setOpen(true);
      setSubmitSucceeded(false);
      setIsOutputModalOpen(true);
    }
  });

  const handleCloseConfirmModal = () => {
    console.log("handle close confirm modal");
    setOpen(false);
    handleClose();
    setRefreshKey(prev => prev + 1);
  };

  const handleCloseModalAndRefresh = () => {
    console.log("handle close modal and refresh print, refreshKey: ",refreshKey);
    setOpen(false);
    setRefreshKey(prev => prev + 1);
    //window.location.reload();
  };

  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);

  const handleClose = () => setOpen(false);


  //const isMedium = useMediaQuery(theme.breakpoints.down("md"));

  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isLarge = useMediaQuery(theme.breakpoints.down("lg"));
  const [isOutputModalOpen, setIsOutputModalOpen] = React.useState(false);
  const handleCloseWithRefresh = () => {
    setIsOutputModalOpen(false);
    setRefreshKey(prev => prev + 1);
  };
  const [submitSucceeded, setSubmitSucceeded] = useState<boolean>();


  if (coursesAreLoading) {
    return (
      <Box
        sx={ { display: "flex", justifyContent: "center", alignItems: "center", minHeight: 400 } }
      >
        <CircularProgress color="secondary" />
      </Box>
    );
  }




  return (
    <>
      <Box
        sx={ {
          background: theme.customColors.backgroundPrimary,
          border: `${theme.customColors.borderAccent} 1px solid`,
          borderRadius: "12px",
          marginBottom: 4,
          padding: isMobile ? 2 : 3,
          width: "100%"
        } }
      >
        <ContentBox
          sx={ {
            alignItems: "center",
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
            gap: 2,
            justifyContent: "space-between"
          } }
        >
          <Typography variant="h6" color={ theme.customColors.exploreCardText } fontSize={ isMobile ? "1rem" : "1.25rem" } sx={ { marginRight: "auto" } }>
            { t("upload_external_training") }
          </Typography>

          <Description>
            <Button
              variant="contained"
              onClick={ handleOpen }
              sx={ {
                textTransform: "none",
                fontSize: "16px"
              } }
            >
              { t("upload_skillBook") }
              <Icon
                icon="Icons_upload"
                size={ 24 }
                sx={ { paddingLeft: "6px" } }
              />
            </Button>
          </Description>
        </ContentBox>
        <ModalBasic
          open={ open }
          title={ "" }
          content={ <ExternalTrainingModal closeModal={ handleCloseModalAndRefresh  } /> }
          handleClose={ handleCloseConfirmModal }
        />
      </Box>
      { courses.length > 0 && (
        <CommonWidgetContainer
          sx={ {
            display: "flex",
            flexDirection: isLarge ? "column" : "row",
            maxWidth: "100%",
            width: "100%",
            borderRadius: "16px",
            alignItems: "flex-start",
            gap: 0,
            mt: 2,
            color:theme.customColors.exploreCardText
          } }
        >
          <SidebarFilters onFilterChange={ handleFilterChange } />

          <Box
            sx={ {
              width: "100%",
              display: "flex",
              alignItems: "flex-start",
              gap: 0,
              mt: 2,
              flex: 1,
              flexDirection: isLarge ? "column" : "row"
            } }
          >
            <Box
              sx={ {
                width: "100%",
                flex: 2,
                p: 2,
                borderLeft:  isLarge ? "none" : `1px solid ${theme.customColors.border}`,
                borderRight: isLarge ? "none" : `1px solid ${theme.customColors.border}`,
                borderTop:   isLarge ? `1px solid ${theme.customColors.border}` : "none",
                borderBottom:isLarge ? `1px solid ${theme.customColors.border}` : "none",
                minWidth: 0,
                overflowX: "auto"
              } }
            >

              <ExternalSidebar
                filter={ filter }
                selectedStatus={ selectedStatusFilter }
                setSelectedStatus={ setSelectedStatusFilter }
                searchTerm={ searchTerm }
                setSearchTerm={ setSearchTerm }
              />

              { /* Tabella dei risultati */ }
              <Box sx={ { width: "100%" } }>

                <Box sx={ { width: "100%" } }>
                  <CoursesTable
                    courses={ filteredCourses }
                    selectedCourse={ selectedCourse }
                    onSelect={ handleSelectCourse }
                    filter={ filter }
                    paginatedCourses={ paginatedCourses }
                    currentPage={ currentPage }
                    itemsPerPage={ itemsPerPage }
                    setCurrentPage={ setCurrentPage }
                  />
                </Box>

              </Box>

            </Box>

            <Box
              sx={ {
                flex: 1,
                p: 1,
                pr: 2,
                display: "flex",
                flexDirection: "column",
                position: "relative",
                width: "100%",
                pl: "25px"
              } }
            >

              <ExternalTrainingPage
                formValues={ formValues }
                setFormValues={ setFormValues }
                filter={ filter }
                formData={ formData }
                handleDateChange={ handleDateChange }
                courseTypes={ courseTypes }
                campaignOptions={ campaignOptions }
                knowledgeAreas={ knowledgeAreas }
                knowledgeDomains={ knowledgeDomains }
                capabilities={ capabilities }
                handleInputChange={ handleInputChange }
                setSelectedArea={ setSelectedArea }
                handleChangeMultiSelect={ handleChangeMultiSelect }
                selectedCourse={ selectedCourse }
                errors={ errors }
                completedFlag={ completed }
                setCompletedFlag={ setCompleted }
                readOnly={
                  selectedCourse?.status === "PENDING" ||
                  !selectedCourse ||
                  ( selectedCourse?.status === "APPROVED" && selectedCourse.type === "Consuntivazione") ||
                  selectedCourse?.status === "REJECTED"
                }
              />



              <ButtonGroupsExternalTrainings
                onClickDelete={ onDelete }
                onClickCancel={ onCancel }
                onClickConfirm={ handleConfirm }
                isPending={ selectedCourse?.status === "PENDING" }
                isCourseSelected={ selectedCourse?.status === "APPROVED" && selectedCourse?.type === "Consuntivazione" }
              />
              <ModalBasic
                open={ isOutputModalOpen }
                title={ "" }
                content={ <OutputMessageModal success={ submitSucceeded ?? false } closeModal={ handleCloseWithRefresh } /> }
                size={ { width: { xs: "100vw", sm: "40vw" } } }
                handleClose={ handleCloseWithRefresh }
              />

              <ModalBasic
                open={ isDeleteModalOpen }
                title={ deleteSuccess ? t("delete_success") : t("delete_failed") }
                content={
                  <Box textAlign="center">
                    <Typography variant="body1" sx={ { mb: 3 } }>
                      { deleteSuccess
                        ?  t("delete_course_success")
                        : t("delete_course_failed") }
                    </Typography>
                    <Button
                      onClick={ () => {
                        setIsDeleteModalOpen(false);
                        setDeleteSuccess(null);
                        handleRefresh();

                      } }
                      variant="contained"
                      sx={ {
                        backgroundColor: "#F43E63",
                        color: theme.customColors.textPrimary,
                        "&:hover": {
                          backgroundColor: "#d63256"
                        },
                        px: 4,
                        fontWeight: "bold",
                        borderRadius: 2,
                        textTransform: "uppercase"
                      } }
                    >
                      { t("close") }
                    </Button>
                  </Box>
                }
                handleClose={ handleRefresh }
                size={ { width: { xs: "100vw", sm: "30vw" } } }
              />
            </Box>

          </Box>

        </CommonWidgetContainer>
      ) }
    </>
  );
}
